module.exports = __webpack_public_path__ + "media/interview2.a8fd5b12.mp3";